const Countries = [
    "US", "CA", "GB", "AU", "DE", "FR", "IT", "ES", "NL", "PL",
    "SE", "NO", "FI", "DK", "IE", "PT", "BE", "CH", "AT", "CZ",
    "SK", "HU", "RO", "BG", "GR", "SI", "HR", "EE", "LV", "LT",
    "LU", "MT", "CY", "NZ", "AE", "IL", "TR", "MX", "BR", "AR",
    "ZA", "BD"
];
export default Countries;